interface FloatingActionsProps {
  onOpenChat: () => void;
  onOpenLeaderboard: () => void;
  hasUnreadChat?: boolean;
}

const SIZE_CLASS = 'w-11 h-11 sm:w-12 sm:h-12';
const ICON_CLASS = 'w-5 h-5 sm:w-[22px] sm:h-[22px]';

export function FloatingActions({
  onOpenChat,
  onOpenLeaderboard,
  hasUnreadChat,
}: FloatingActionsProps) {
  return (
    <div
      className="fixed bottom-[22px] right-4 sm:right-6 z-30 flex items-center gap-2"
      role="group"
      aria-label="Floating actions"
    >
      {/* Leaderboard — glass style, secondary */}
      <button
        type="button"
        onClick={onOpenLeaderboard}
        className={`${SIZE_CLASS} rounded-full flex items-center justify-center touch-manipulation
          bg-wall-surface/90 backdrop-blur-md border border-wall-border/60
          text-wall-muted hover:text-wall-accent hover:border-wall-accent/40 hover:bg-wall-surface
          shadow-lg shadow-black/20 transition-all duration-200 hover:scale-105 active:scale-95`}
        aria-label="Open leaderboard"
      >
        <svg className={ICON_CLASS} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          />
        </svg>
      </button>

      {/* Chat — primary, glass + accent border & glow (in line with page design) */}
      <button
        type="button"
        onClick={onOpenChat}
        className={`${SIZE_CLASS} rounded-full flex items-center justify-center touch-manipulation relative
          bg-wall-surface/90 backdrop-blur-md
          border border-wall-accent/50 text-wall-accent
          shadow-lg shadow-black/20
          hover:border-wall-accent hover:shadow-glow hover:bg-wall-surface/95
          transition-all duration-200 hover:scale-105 active:scale-95`}
        aria-label={hasUnreadChat ? 'Open chat (new messages)' : 'Open chat'}
      >
        <svg className={ICON_CLASS} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>
        {hasUnreadChat && (
          <span
            className="absolute top-1 right-1 w-2.5 h-2.5 rounded-full bg-wall-accent shadow-[0_0_0_2px_var(--color-wall-surface)] animate-pulse"
            aria-hidden
          />
        )}
      </button>
    </div>
  );
}
